import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, MessageCircle, User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const navItems = [
  { path: '/dashboard', icon: Home, label: 'Home' },
  { path: '/explore', icon: Search, label: 'Explore' },
  { path: '/messages', icon: MessageCircle, label: 'Messages' },
  { path: '/profile', icon: User, label: 'Profile' },
];

export default function Layout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-[#FDFBF7] pb-24">
      {children}
      <nav
        className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-gray-100 px-6 py-3 flex justify-between items-center z-50 rounded-t-3xl shadow-[0_-5px_20px_rgba(0,0,0,0.05)] max-w-lg mx-auto"
        data-testid="bottom-nav"
      >
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = location.pathname === path || location.pathname.startsWith(path + '/');
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center gap-1 transition-all min-w-[60px] py-1 ${
                isActive
                  ? 'text-[#2EC4B6] scale-110'
                  : 'text-gray-400 hover:text-gray-600'
              }`}
              data-testid={`nav-${label.toLowerCase()}`}
            >
              <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
              <span className="text-[11px] font-bold">{label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
